import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Col,
  Input,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Spinner,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import Categories from "./WaiterMenu/Categories";
import CartLogo from "./WaiterMenu/AddToCart/CartLogo";
import WaiterCart from "./WaiterCart";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddOrder from "./WaiterMenu/AddOrder";
import UpdateOrder from "./WaiterMenu/UpdateOrder";
import { useHolidayGuard } from "hooks/useHolidayGuard";

const WaiterResturants = ({ menus, loadingMenu }) => {
  const location = useLocation();
  const history = useHistory();

  const { user, userPermissions } = useSelector((state) => state.auth);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);
  const { cartItems } = useSelector((state) => state.cart);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCart, setShowCart] = useState(false);
  const [isAddorderOpen, setIsAddorderOpen] = useState(false);
  const [isUpdateorderOpen, setIsUpdateorderOpen] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const [selectedTab, setSelectedTab] = useState(null);
  const tabParam = queryParams.get("menu");

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  };

  const handleCartToggle = () => {
    const searchParams = new URLSearchParams(location.search);
    if (showCart) {
      searchParams.delete("cart");
      history.replace({ search: searchParams.toString() });
    } else {
      searchParams.set("cart", "true");
      history.replace({ search: searchParams.toString() });
    }
  };

  const { holidayStatus, checkAndToast } = useHolidayGuard(
    restaurantsDetail,
    "dinein"
  );

  const AddOrderToggler = () => {
    if (!isAddorderOpen) {
      if (checkAndToast()) return;

      setIsAddorderOpen(!isAddorderOpen);
    } else {
      setIsAddorderOpen(!isAddorderOpen);
    }
  };
  const UpdateOrderToggler = () => {
    if (!isAddorderOpen) {
      if (checkAndToast()) return;
      setIsUpdateorderOpen(!isUpdateorderOpen);
    } else {
      setIsUpdateorderOpen(!isUpdateorderOpen);

    }
  };

  //Set default tab from menus when menus are available
  useEffect(() => {
    if (menus?.length > 0) {
      const defaultTabId = tabParam || menus[0]?.id;
      setSelectedTab(defaultTabId);

      const searchParams = new URLSearchParams(location.search);
      if (!tabParam) {
        searchParams.set("menu", defaultTabId);
        history.replace({ search: searchParams.toString() });
      }
    }
  }, [menus, history, tabParam, location.search]);

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    if (selectedTab && selectedTab !== tabParam) {
      search.set("menu", selectedTab);
      history.replace({ search: search.toString() });
    }
  }, [selectedTab, history, location.search, tabParam]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isCartOpen = searchParams.get("cart") === "true";

    setShowCart(isCartOpen);
  }, [location.search]);

  return (
    <>
      {showCart ? (
        <WaiterCart toggleCart={handleCartToggle} cartItemsData={cartItems} />
      ) : (
        <>
          <CardHeader className="p-0 pt-4 d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center">
            {loadingMenu ? (
              <div className="w-100 d-flex justify-content-center align-items-center py-5">
                <Spinner size="md" color="primary" />
              </div>
            ) : (
              <Nav pills>
                {menus
                  .filter((menu) => menu.hasItems)
                  .map((tab) => {
                    const isActive = selectedTab === tab.id;
                    return (
                      <NavItem
                        key={tab.id}
                        className={`text-center cursor-pointer px-4 py-1 ${
                          isActive &&
                          "text-primary border-bottom border-primary"
                        }`}
                        onClick={() => {
                          setSelectedTab(tab.id);
                        }}
                      >
                        <h3 className={`${isActive && "text-primary"}`}>
                          {tab.name}
                        </h3>
                      </NavItem>
                    );
                  })}
              </Nav>
            )}
          </CardHeader>

          {!loadingMenu && userPermissions?.menus?.category?.active ? (
            <>
              <Row className="justify-content-end px-4 py-3 mx-0 border-lighter border-bottom">
                <Col md="6" lg="6" xl="3" className="mb-2">
                  <Input
                    placeholder="Search Categories"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </Col>
                <Col md="6" lg="6" xl="3" className="mb-2 d-xl-none">
                  <Button
                    className="w-100 d-flex justify-content-center align-items-center py-0"
                    onClick={handleCartToggle}
                    style={{ minHeight: "43px" }}
                  >
                    <CartLogo variant="small" />
                    View Cart
                  </Button>
                </Col>
                <Col md="6" lg="6" xl="3" className="mb-2">
                  <Button
                    color="success"
                    className="w-100"
                    onClick={AddOrderToggler}
                  >
                    Add Order
                  </Button>
                </Col>
                <Col md="6" lg="6" xl="3" className="mb-2">
                  <Button
                    color="primary"
                    className="w-100"
                    onClick={UpdateOrderToggler}
                  >
                    Update Order
                  </Button>
                </Col>
                <Col
                  className="mb-2 d-none d-xl-flex justify-content-end px-0"
                  style={{ maxWidth: "65px" }}
                >
                  <Button
                    className="w-auto px-0 py-0 d-flex justify-content-center align-items-center bg-transparent shadow-none"
                    onClick={handleCartToggle}
                  >
                    <CartLogo />
                  </Button>
                </Col>
              </Row>

              <Categories searchQuery={searchQuery} />
            </>
          ) : (
            !loadingMenu &&
            user?.type === "kitchen-waiter" &&
            !userPermissions?.menus?.category?.active && (
              <Row className="py-4 justify-content-center align-items-center">
                You don't have permission to access this page.
              </Row>
            )
          )}
        </>
      )}
      <AddOrder isOpen={isAddorderOpen} toggler={AddOrderToggler} />
      <UpdateOrder isOpen={isUpdateorderOpen} toggler={UpdateOrderToggler} />
    </>
  );
};

export default WaiterResturants;
